import { render } from "./SelectYear.vue?vue&type=template&id=c6af5058&scoped=true"
import script from "./SelectYear.vue?vue&type=script&lang=js"
export * from "./SelectYear.vue?vue&type=script&lang=js"

import "./SelectYear.vue?vue&type=style&index=0&id=c6af5058&scoped=true&lang=css"

import exportComponent from "/home/user/dev/teacher-soft/datepickerDev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6af5058"]])

export default __exports__